export const buttonBoxStyles = theme => ({
  '&:last-child > span > svg': {
    color: 'rgba(1, 11, 26, 0.54)',
    marginLeft: theme.spacing(-1),
  },
  '&:not(:last-child)': {
    borderRadius: 4,
    borderRightColor: theme.palette.text.disabled,
    minWidth: 34,
  },
  '&:nth-child(2)': {
    marginLeft: 2,
    marginRight: theme.spacing(1),
    minWidth: 34,
  },
  borderColor: theme.palette.text.disabled,
  display: 'flex',
  fontSize: 24,
  justifyContent: 'space-between',
  marginLeft: theme.spacing(0.5),
  maxHeight: 32,
  width: 112,
});

export const buttonLabelStyles = {
  fontSize: 32,
  height: '100%',
  margin: 'auto',
  textAlign: 'center',
};

export const chainedCustomerDivStyles = theme => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: 56,
  padding: theme.spacing(0, 3),
  width: '100%',
});

export const iconContainerStyles = {
  padding: 0,
};

export const recipientRequiredStyles = theme => ({
  alignSelf: 'center',
  paddingLeft: theme.spacing(2),
});

export const sectionDivStyles = theme => ({
  marginBottom: 21,
  padding: theme.spacing(3, 0),
  width: '100%',
});
